import React from 'react';
import MaskedInput from 'src/ui/library/MaskedInput/MaskedInput';
import PropTypes from 'prop-types';

const setInputRef = (maskedInputRef, inputRef, forwardedRef) => {
  const inputElement = maskedInputRef ? maskedInputRef.inputElement : null;

  if (typeof inputRef === 'function') {
    inputRef(inputElement);
  }

  if (typeof forwardedRef === 'function') {
    forwardedRef(inputElement);
  } else if (forwardedRef) {
    forwardedRef.current = inputElement;
  }
};

const TextMask = React.forwardRef((props, ref) => {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={maskedInputRef => setInputRef(maskedInputRef, inputRef, ref)}
      mask={['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
      placeholderChar={'\u2000'}
      guide={false}
      showMask
    />
  );
});

TextMask.displayName = 'TextMask';

TextMask.propTypes = {
  inputRef: PropTypes.func,
};

export default TextMask;
